import { useState, useCallback } from 'react'
import { useTransactionDetails } from 'modules/blockChain/hooks/useTransactionDetails'

export function useNFCSModalAddState() {
  const [showFormAddState, setFormAdd] = useState(false)

  const [txHash, setTxHash] = useState<string | null>(null)

  const removeTxHash = useCallback(() => {
    setTxHash(null)
  }, [])

  const { txStatus } = useTransactionDetails({
    hash: txHash,
    defaultStatus: 'empty',
    onSuccess: removeTxHash,
  })

  const handleSubmitAdd = useCallback(
    (e: string) => {
      setFormAdd(false)
      setTxHash(e)
    },
    [setTxHash],
  )

  const handleClickAddAddress = useCallback(() => {
    setFormAdd(true)
  }, [])

  return {
    txHash,
    txStatus,
    showFormAddState,
    handleClickAddAddress,
    handleSubmitAdd,
  }
}
